var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"text-left text-default mb-5"},[_vm._v(_vm._s(_vm.clientFullName))])
}
var staticRenderFns = []

export { render, staticRenderFns }